import { downloadZip } from 'client-zip';

import { ApiService } from '../services/api.service';
import { VisitorIdService } from '../services/visitor-id.service';

let postId;
let postUrl;

/**
 * Read text of a post out aloud
 */
function initSpeech() {
    let selectedVoice;
    let selectedVoiceIndex;
    let utterance;
    let voices = [];

    const buttonTts = document.getElementById('button-tts');
    const pitchSlider = document.getElementById('tts-pitch-slider');
    const pitchValueDisplay = document.querySelector('.tts-pitch-value');
    const speedSlider = document.getElementById('tts-speed-slider');
    const speedValueDisplay = document.querySelector('.tts-speed-value');
    const synth = window.speechSynthesis;
    const voiceSelect = document.getElementById('tts-voice-select');
    const textContainer = document.querySelector('.post-contents');
    // TODO parse out image and replace by something like "embedded image from <the domain of the URL>"
    // TODO and also links
    const textToRead = textContainer.innerText;

    function populateVoiceList() {
        voices = synth
            .getVoices()
            .map(voice => {
                // Remove parentheses (and parts between them) in the voice name
                voice.cleanName = voice.name.replace(/\(.*\)/, '').trim();
                return voice;
            })
            .sort((a, b) => {
                const aLang = a.lang.toUpperCase();
                const bLang = b.lang.toUpperCase();
                const aName = a.cleanName.toUpperCase();
                const bName = b.cleanName.toUpperCase();

                if(aLang < bLang) {
                    return -1;
                } else if(aLang === bLang) {
                    // Sort by name within the same language
                    return aName.localeCompare(bName);
                } else {
                    return 1;
                }
            });

        selectedVoiceIndex = voiceSelect.selectedIndex < 0 ? 0 : voiceSelect.selectedIndex;
        voiceSelect.innerHTML = '';

        let currentLang = null;

        for(let i = 0; i < voices.length; i++) {
            const option = document.createElement('option');

            if(voices[i].lang !== currentLang) {
                // Create an OPTGROUP for each language
                const optgroup = document.createElement('optgroup');
                optgroup.label = voices[i].lang;
                voiceSelect.appendChild(optgroup);
                currentLang = voices[i].lang;
            }

            option.textContent = voices[i].cleanName;

            if(voices[i].default) {
                option.textContent += ' [DEFAULT]';
                option.classList.add('default-voice');
                selectedVoiceIndex = selectedVoiceIndex || i;
            }

            option.setAttribute('data-lang', voices[i].lang);
            option.setAttribute('data-name', voices[i].name);
            voiceSelect.lastChild.appendChild(option);
        }

        voiceSelect.selectedIndex = selectedVoiceIndex;
        selectedVoice = voices[selectedVoiceIndex];
    }

    function speak() {
        if(synth.speaking) {
            console.error("speechSynthesis.speaking");
            synth.cancel();
        }

        console.log('speak!!', textToRead);
        const currentVoice = voices[selectedVoiceIndex];
        utterance = new SpeechSynthesisUtterance(textToRead);

        utterance.addEventListener('end', event => {
            console.log('SpeechSynthesisUtterance.onend', event);
        });

        utterance.addEventListener('error', event => {
            console.error('SpeechSynthesisUtterance.onerror', event);
        });

        utterance.rate = speedSlider.value;
        utterance.pitch = pitchSlider.value;
        utterance.voice = currentVoice;
        utterance.lang = currentVoice.lang;
        console.log('speak!!', selectedVoiceIndex, currentVoice, utterance);
        synth.speak(utterance);
    }

    // in Google Chrome the voices are not ready on page load
    // if ('onvoiceschanged' in synth) {
    if(synth.onvoiceschanged !== undefined) {
        synth.onvoiceschanged = populateVoiceList;
    } else {
        populateVoiceList();
    }

    buttonTts.addEventListener('click', speak);
    voiceSelect.addEventListener('change', () => {
        // set selectedVoice

        const selected = voiceSelect.selectedOptions[0].getAttribute("data-name");

        for(let i = 0; i < voices.length; i++) {
            if(voices[i].name === selected) {
                selectedVoiceIndex = i;
                selectedVoice = voices[selectedVoiceIndex];
                break;
            }
        }

        console.log('change voice', selectedVoiceIndex, selectedVoice, voices);
        speak();
    });
    pitchSlider.addEventListener('input', () => {
        const pitchValue = parseFloat(pitchSlider.value).toFixed(1);
        pitchValueDisplay.textContent = pitchValue;
        utterance.pitch = pitchValue;
    });
    speedSlider.addEventListener('input', () => {
        const speedValue = parseFloat(speedSlider.value).toFixed(1);
        speedValueDisplay.textContent = speedValue;
        utterance.rate = speedValue;
    });
}

/**
 * Download all images from post as a zipfile
 */
function initDownloadImages() {
    const button = document.getElementById('button-download-images');
    const imagesToDownload = document.querySelectorAll('img[data-download]');
    const loadedImages = Array.from(imagesToDownload).filter(

        // images that didn't download have no width so filter them out
        image => image.naturalWidth > 0
    );

    if(loadedImages.length > 0) {
        const text = loadedImages.length === 1 ? 'Download the image' : `Download all ${loadedImages.length} images`
        button.classList.remove('disabled');
        button.setAttribute('title', `${text} from this post`);
        button.removeAttribute('disabled');
        button.setAttribute('data-image-count', loadedImages.length.toString());
        button.addEventListener('click', handleDownload);
    }

    /**
     * Creates the filename of the zip file
     *
     * @returns {string} the filename e.g. 'kf-images-20241215-163656.zip'
     */
    function createFileName() {
        const currentDate = new Date();
        const year = currentDate.getFullYear().toString().slice(-2);
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const day = currentDate.getDate().toString().padStart(2, '0');
        const hours = currentDate.getHours().toString().padStart(2, '0');
        const minutes = currentDate.getMinutes().toString().padStart(2, '0');
        const seconds = currentDate.getSeconds().toString().padStart(2, '0');
        return `kf-images-${year}${month}${day}${hours}${minutes}${seconds}.zip`;
    }

    /**
     * Extracts the last part of the path (the filename) and returns it
     *
     * @param {string} url
     * @returns {string} the filename
     */
    function getFileName(url) {
        const urlObject = new URL(url);
        return urlObject.pathname.split('/').pop();
    }

    /**
     * Adds padding zeros
     *
     * @param number
     * @param length
     * @returns {string}
     */
    function pad(number, length) {
        return String(number).padStart(length, '0');
    }

    /**
     * Automagically save the provided blob file
     *
     * @param blob file contents
     */
    function saveFileAs(blob) {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = createFileName();
        link.click();
        link.remove();
        window.URL.revokeObjectURL(link.href);
    }

    /**
     * Creates a zip archives containing all images in the post and downloads
     * the zip to the clients device
     *
     * @returns {Promise<void>}
     */
    async function handleDownload() {
        const buttonText = button.getAttribute('title');
        button.classList.add('disabled');
        button.setAttribute('title', 'preparing download...');
        button.setAttribute('disabled', 'disabled');
        button.classList.add('loading');

        // FIXME add spinner

        const padding = loadedImages.length.toString().length;

        try {
            const images = await Promise.all(
                loadedImages.map(async (image, index) => {
                    const imageUrl = image.src;
                    const imageName = `${pad(index + 1, padding)}-${getFileName(imageUrl)}`;

                    // directly fetch
                    // try{
                    //     const response = await fetch(imageUrl,{
                    //         headers: {
                    //             // ,*/*;q=0.5
                    //             'Accept': 'image/webp,image/apng,image/jpeg,image/gif,image/heic,image/*;q=0.8',
                    //             'Accept-Encoding': 'gzip, deflate, br',
                    //             'Connection': 'keep-alive',
                    //             'Referer': window.location.href,
                    //             'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36'
                    //         },
                    //         mode: 'no-cors'
                    //     });
                    //
                    //     return {
                    //         name: imageName,
                    //         input: await response.blob()
                    //     }
                    // } catch(error){
                    //     console.error(`Error fetching image: ${imageUrl}`, error);
                    // }

                    // use proxy
                    try {
                        const params = {
                            action: 'proxy',
                            url: imageUrl
                        };
                        const response = await ApiService.get(params);

                        return {
                            name: imageName,
                            input: await response.blob()
                        };
                    } catch (error) {
                        console.error(`Error fetching image: ${imageUrl}`, error);
                        // error can be handled as needed
                        // Returning null for the failed image
                        return null;
                    }

                })
            );

            // Remove null entries from images
            const filteredImages = images.filter(image => image !== null);
            const blob = await downloadZip(filteredImages).blob();
            saveFileAs(blob);
        } catch (error) {
            console.error('Error handling download:', error);
            // TODO Handle the overall download error - display something in UI
        } finally {
            button.classList.remove('disabled');
            button.classList.remove('loading');
            button.setAttribute('title', buttonText);
            button.removeAttribute('disabled');
        }
    }


    // async function handleDownload() {
    //     button.classList.toggle('disabled', true);
    //     const padding = loadedImages.length.toString().length;
    //     const images = await Promise.all(
    //         loadedImages.map(async (image, index) => {
    //             const imageUrl = image.src;
    //             const imageName = `${pad(index + 1, padding)}-${getFileName(imageUrl)}`;
    //             const params = {
    //                 action: 'proxy',
    //                 url: imageUrl
    //             };
    //
    //             const response = await ApiService.get(params);
    //
    //             return {
    //                 name: imageName,
    //                 // lastModified: new Date(), // use post date?
    //                 input: await response.blob()
    //             }
    //         })
    //     );
    //
    //     const blob = await downloadZip(images).blob()
    //     saveFileAs(blob);
    //     button.classList.toggle('disabled', false);
    // }
}

/**
 * Activates the like / dislike buttons
 */
async function initScore() {
    const dislikesCount = document.querySelector('[data-dislikes]');
    const icons = document.querySelectorAll('[data-action]');
    const likesCount = document.querySelector('[data-likes]');

    const currentDislikes = parseInt(dislikesCount.innerText, 10);
    const currentLikes = parseInt(likesCount.innerText, 10);
    const currentScore = 0;

    // TODO move to regular function
    // this.currentScore = await getScore();
    // this.updateUi({
    //     dislikes: this.currentDislikes,
    //     likes: this.currentLikes,
    //     score: this.currentScore
    // });
    //
    // for(const icon of this.icons) {
    //     icon.addEventListener('click', event => this.clickButton(icon, event));
    // }

    /**
     * Updates the current likes, dislikes and user score
     *
     * @param data - object containing likes, dislikes and score
     * @param {number} data.dislikes - the number of dislikes
     * @param {number} data.likes - the number of likes
     * @param {number} data.score - the user's score
     * @returns {void}
     */
    // function updateUi(data) {
    //     console.log('>>> update UI', data);
    //     this.currentLikes = data.likes;
    //     this.currentDislikes = data.dislikes;
    //     this.currentScore = data.score;
    //
    //     this.likesCount.innerText = this.currentLikes;
    //     this.dislikesCount.innerText = this.currentDislikes;
    //
    //     for(const icon of this.icons) {
    //         if(icon.dataset.action === 'like') {
    //             icon.classList.toggle('scored', this.currentScore === 1);
    //         } else if(icon.dataset.action === 'dislike') {
    //             icon.classList.toggle('scored', this.currentScore === -1);
    //         }
    //     }
    // }

    // /**
    //  * Returns the URL to use to fetch data from
    //  *
    //  * @todo remove in favour of ApiService
    //  * @param {object} [params] - optional data object to use as query parameters
    //  * @returns {URL} - the URL to fetch data from
    //  */
    // getFetchUrl(params) {
    //     const url = new URL(window.location.origin + '/forum/xhr.php');
    //
    //     if(params) {
    //         Object.keys(params).forEach(
    //             key => url.searchParams.append(key, params[key])
    //         );
    //     }
    //
    //     return url;
    // }
    //
    // /**
    //  * Fetches the user's score
    //  *
    //  * @returns {Promise<number>}
    //  */
    // async getScore() {
    //     const params = {
    //         post_id: this.postId,
    //         visitor_id: this.visitorId
    //     };
    //     // FIXME use ApiService
    //     const url = this.getFetchUrl(params);
    //     const response = await fetch(url);
    //     const data = await response.json();
    //     return data.score;
    // }
    //
    // /**
    //  * Called when a thumbs up or down icon was clicked by the user
    //  *
    //  * @param icon - the icon that was clicked
    //  * @param event - the click event
    //  * @returns {void}
    //  */
    // async clickButton(icon, event) {
    //     const action = icon.dataset.action;
    //     let score = action === 'like' ? 1 : -1;
    //     score = this.currentScore === score ? 0 : score;
    //
    //     // optimistic ui update
    //     let updatedDislikes = this.currentDislikes;
    //     let updatedLikes = this.currentLikes;
    //
    //     if(action === 'dislike' && this.currentScore === 0) {
    //         updatedDislikes += 1;
    //     }
    //
    //     if(action === 'dislike' && this.currentScore === 1) {
    //         updatedDislikes += 1;
    //         updatedLikes -= 1;
    //     }
    //
    //     if(action === 'dislike' && this.currentScore === -1) {
    //         updatedDislikes -= 1;
    //     }
    //
    //     if(action === 'like' && this.currentScore === 0) {
    //         updatedLikes += 1;
    //     }
    //
    //     if(action === 'like' && this.currentScore === 1) {
    //         updatedLikes -= 1;
    //     }
    //
    //     if(action === 'like' && this.currentScore === -1) {
    //         updatedDislikes -= 1;
    //         updatedLikes += 1;
    //     }
    //
    //     this.updateUi({
    //         dislikes: updatedDislikes,
    //         likes: updatedLikes,
    //         score: score
    //     });
    //
    //     const url = this.getFetchUrl();
    //
    //     const payload = {
    //         action: 'score',
    //         data: {
    //             post_id: this.postId,
    //             score: score,
    //             visitor_id: this.visitorId
    //         }
    //     };
    //
    //     const response = await fetch(url, {
    //         method: 'POST',
    //         mode: 'same-origin',
    //         cache: 'no-cache',
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json'
    //         },
    //         redirect: 'follow',
    //         referrerPolicy: 'no-referrer',
    //         body: JSON.stringify(payload)
    //     });
    //
    //     const json = await response.json()
    //     this.updateUi(json);
    // }
}


/**
 * Registers a view for the specified visitor
 */
async function countView(visitorId, postId) {
    // FIXME remove visitor_id, it's present as a header in ApiService.fetch()
    await ApiService.post({
        action: 'view',
        data: {
            post_id: postId,
            visitor_id: visitorId
        }
    });
}

function initShare(){}
/**
 * Class that handles viewing a post
 */
export class TopicView {
    /**
     * initialises the object
     *
     * @returns {void}
     */
    async init() {
        // set up variables
        const postId = document.querySelector('[data-id]').dataset.id;
        const visitorId = await VisitorIdService.getId();

        // register a view
        await countView(visitorId, postId);

        // initialise functionality
        // initScore();
        initDownloadImages();
        initShare();
    }
}

